import React from 'react'
import Layout from '../../components/Layout'

const CategoriesPage = () => {
    return (
        <React.Fragment>
            CategoriesPage
        </React.Fragment>
    )
}

export default CategoriesPage
